module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    attrs: {
      "slot": "insertComponent",
      "id": "d-add-calendar-to-cost-center"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Vælg kalendere")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.activeTab
    },
    on: {
      "select": function($event) {
        _vm.activeTab = $event
      }
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "do-table do-table__items marg-1-top"
  }, [_c('thead', [_c('tr', [_c('th', [_c('p', {
    staticClass: "text-link",
    on: {
      "click": _vm.toggleSelectAll
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isAllChecked ? 'Fravælg alle' : 'Vælg alle ') + "\n            ")])]), _vm._v(" "), _c('th', [_vm._v("Navn")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.filteredCalendars), function(calendar) {
    return _c('tr', {
      key: calendar.id,
      class: {
        'row-selected': _vm.localSelectedIds.indexOf(calendar.id) > -1
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.toggleOne(calendar.id)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "80px"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.localSelectedIds.indexOf(calendar.id) > -1
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleOne(calendar.id)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(calendar.name))])])
  }), _vm._v(" "), (_vm.filteredCalendars.length === 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('i', [_vm._v("Ingen kalendere")])])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "do-modal__buttons do-modal__buttons--end"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.common.cancel')) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--disabled': _vm.isSubmitting,
      'do-bttn--submit--loading': _vm.isSubmitting
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n        Gem\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20eb7604!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/CostCentersCenterCalendarsModal.vue
// module id = 1797
// module chunks = 1